module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-341eb6ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LargePicture.vue
// module id = 256
// module chunks = 0